<script lang="ts">
	//Stores
	import { user_settings } from 'src/stores/account/user';
import { app, os } from 'src/stores/session/native-bridge';
import { initializing_language } from 'src/stores/session/preferences';
	//Services
	import { setUpI18n, format } from '../../../../services/i18n';
	import { postReq } from '../../../../services/http';
	import { change_lang_ios } from '../../../../services/native_container_requests_ios';
	//Constants
	import { LANG_DICT } from '../../../../constants';
	//Design system components
	import { ButtonV2, SelectV2, Stack, Text } from '@Shelly/shelly-design-system';

	let selected = LANG_DICT[$user_settings.lang in LANG_DICT ? $user_settings.lang : 'en'];
	let initialSelected = LANG_DICT[$user_settings.lang in LANG_DICT ? $user_settings.lang : 'en'];

	$: hasLanguageChanged = selected !== initialSelected;

	const handle_select = async () => {
		let lang = Object.entries(LANG_DICT).filter((e) => e[1] === selected)[0][0];
		if ($user_settings.lang !== lang) {
			const activeLang = await setUpI18n(lang);
			initializing_language.set(activeLang);
			user_settings.set({ ...$user_settings, lang: activeLang });
			await postReq('/user/set_language', { lang: activeLang });

			if ($app) {
				if ($os === 'IOS') {
					change_lang_ios(activeLang);
				}
			}
			initialSelected = selected;
		}
	};
</script>

<Stack
	direction="column"
	directionMobile="row"
	align="between"
	alignMobile="none"
	gap="m"
	class="align-items-center"
>
	<div>
		<Text class="mb-s" styleType="body">{$format('label_language', { default: 'Language' })}</Text>
		<SelectV2
			aria-label={$format('select_language', { default: 'Select language' })}
			bind:value={selected}
			width="full"
			icon="fas fa-language"
			options={Object.values(LANG_DICT)}
			id="select-8sv1hpa"
			class="mr-s"
		/>
	</div>

	<ButtonV2 size="m" variant="secondary" disabled={!hasLanguageChanged} on:click={handle_select}>
		{$format('button_save')}
	</ButtonV2>
</Stack>
